import { DirectivesModule } from '$shared/directives/directives.module';
import { PipesModule } from '$shared/pipes/pipes.module';
import { ValidatorsModule } from '$shared/validators/validators.module';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { AddressItemComponent } from './address-item/address-item.component';
import { AlertMessageComponent } from './alert-message/alert-message.component';
import { AppealItemComponent } from './appeal-item/appeal-item.component';
import { AppointmentButtonComponent } from './appointment-button/appointment-button.component';
import { BadgeComponent } from './badge/badge.component';
import { BankBicLabelComponent } from './bank-bic-label/bank-bic-label.component';
import { BaseBlockComponent } from './base-block/base-block.component';
import { BaseWidgetComponent } from './base-widget/base-widget.component';
import { BoxMapWindowComponent } from './box-map-window/box-map-window.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { CaptchaComponent } from './captcha/captcha.component';
import { CardItemComponent } from './card-item/card-item.component';
import { CargoOrderItemComponent } from './cargo-order-item/cargo-order-item.component';
import { CarouselEyeComponent } from './carousel-eye/carousel-eye.component';
import { CarouselComponent } from './carousel/carousel.component';
import { CartItemComponent } from './cart-item/cart-item.component';
import { ControlErrorsComponent } from './control-errors/control-errors.component';
import { AppOrderDataCourierComponent } from './courier-order-items/app-order-data-courier/app-order-data-courier.component';
import { OrderItemComponent } from './courier-order-items/order-item/order-item.component';
import { EmptyComponent } from './empty/empty.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FilialSelectorComponent } from './filial-selector/filial-selector.component';
import { InputPlusMinusComponent } from './input-plus-minus/input-plus-minus.component';
import { LegalAddressItemComponent } from './legal-address-item/legal-address-item.component';
import { LoadingButtonComponent } from './loading-button/loading-button.component';
import { LoadingCheckboxComponent } from './loading-checkbox/loading-checkbox.component';
import { LocationFieldsComponent } from './location-fields/location-fields.component';
import { MenuItemsComponent } from './menu-items/menu-items.component';
import { NewsPreviewComponent } from './news-preview/news-preview.component';
import { PageBannerComponent } from './page-banner/page-banner.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { ParcelLockerMapWindowComponent } from './parcel-locker-map-window/parcel-locker-map-window.component';
import { PasswordValidationComponent } from './password-validation/password-validation.component';
import { PayFormComponent } from './pay-form/pay-form.component';
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { ProductPreviewComponent } from './product-preview/product-preview.component';
import { RenderBlockComponent } from './render-block/render-block.component';
import { RenderPageComponent } from './render-page/render-page.component';
import { RoutingTabsComponent } from './routing-tabs/routing-tabs.component';
import { ScrollButtonsComponent } from './scroll-buttons/scroll-buttons.component';
import { SearchItemsComponent } from './search-items/search-items.component';
import { ServicePreviewEyeComponent } from './service-preview-eye/service-preview-eye.component';
import { ServicePreviewComponent } from './service-preview/service-preview.component';
import { StepsComponent } from './steps/steps.component';
import { OrderDataItemComponent } from './subscription-order-items/order-data-item/order-data-item.component';
import { OrderSubsciptionItemComponent } from './subscription-order-items/order-subscription-item/order-subscription-item.component';
import { TrackItemComponent } from './track-item/track-item.component';
import { UnpStatusComponent } from './unp-status/unp-status.component';
import { TimerComponent } from './timer/timer.component';
import { CookiesAcceptPopupComponent } from './cookies-accept-popup/cookies-accept-popup.component';
import { NavigationItemListComponent } from './navigation-item-list/navigation-item-list.component';
import { AddressWidgetPickerComponent } from './address-widget-picker/address-widget-picker.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from 'localize-router';
import { NgSelectModule } from '@ng-select/ng-select';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { LegalPostalAddressComponent } from './legal-postal-address';
import { SkeletonComponent } from './skeleton';
import { ContentUnavailableComponent } from './content-unavailable/content-unavailable.component';
import { MapComponent } from './map';

@NgModule({
  declarations: [
    AlertMessageComponent,
    BadgeComponent,
    BaseBlockComponent,
    BaseWidgetComponent,
    BreadcrumbsComponent,
    CarouselComponent,
    ControlErrorsComponent,
    FileUploadComponent,
    InputPlusMinusComponent,
    MenuItemsComponent,
    SearchItemsComponent,
    NewsPreviewComponent,
    PageBannerComponent,
    PageHeaderComponent,
    ProductPreviewComponent,
    RenderBlockComponent,
    RoutingTabsComponent,
    RoutingTabsComponent,
    ServicePreviewComponent,
    RenderPageComponent,
    TrackItemComponent,
    AddressItemComponent,
    AppealItemComponent,
    ServicePreviewEyeComponent,
    CarouselEyeComponent,
    CartItemComponent,
    OrderItemComponent,
    OrderSubsciptionItemComponent,
    OrderDataItemComponent,
    PayFormComponent,
    EmptyComponent,
    LegalAddressItemComponent,
    LegalPostalAddressComponent,
    AppOrderDataCourierComponent,
    ScrollButtonsComponent,
    CardItemComponent,
    PasswordValidationComponent,
    CaptchaComponent,
    FilialSelectorComponent,
    BoxMapWindowComponent,
    CargoOrderItemComponent,
    UnpStatusComponent,
    LoadingButtonComponent,
    ParcelLockerMapWindowComponent,
    PhoneInputComponent,
    BankBicLabelComponent,
    AppointmentButtonComponent,
    StepsComponent,
    LocationFieldsComponent,
    LoadingCheckboxComponent,
    PaginatorComponent,
    TimerComponent,
    CookiesAcceptPopupComponent,
    NavigationItemListComponent,
    AddressWidgetPickerComponent,
    ContentUnavailableComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FontAwesomeModule,
    TranslateModule,
    LocalizeRouterModule,
    NgSelectModule,
    NgxIntlTelInputModule,
    InlineSVGModule,
    PipesModule,
    DirectivesModule,
    ValidatorsModule,
    PaginationModule.forRoot(),
    TooltipModule,
    BsDropdownModule,
    TabsModule,
    SkeletonComponent,
  ],
  exports: [
    AlertMessageComponent,
    BadgeComponent,
    BaseBlockComponent,
    BaseWidgetComponent,
    BreadcrumbsComponent,
    CarouselComponent,
    ControlErrorsComponent,
    FileUploadComponent,
    InputPlusMinusComponent,
    MenuItemsComponent,
    SearchItemsComponent,
    NewsPreviewComponent,
    FilialSelectorComponent,
    PageBannerComponent,
    PageHeaderComponent,
    ProductPreviewComponent,
    RenderBlockComponent,
    RoutingTabsComponent,
    RoutingTabsComponent,
    ServicePreviewComponent,
    RenderPageComponent,
    TrackItemComponent,
    AddressItemComponent,
    AppealItemComponent,
    ServicePreviewEyeComponent,
    CarouselEyeComponent,
    CartItemComponent,
    OrderItemComponent,
    OrderSubsciptionItemComponent,
    OrderDataItemComponent,
    PayFormComponent,
    EmptyComponent,
    LegalAddressItemComponent,
    LegalPostalAddressComponent,
    AppOrderDataCourierComponent,
    ScrollButtonsComponent,
    CardItemComponent,
    PasswordValidationComponent,
    CaptchaComponent,
    BoxMapWindowComponent,
    CargoOrderItemComponent,
    UnpStatusComponent,
    ParcelLockerMapWindowComponent,
    LoadingButtonComponent,
    PhoneInputComponent,
    BankBicLabelComponent,
    AppointmentButtonComponent,
    StepsComponent,
    LocationFieldsComponent,
    LoadingCheckboxComponent,
    PaginatorComponent,
    TimerComponent,
    CookiesAcceptPopupComponent,
    NavigationItemListComponent,
    AddressWidgetPickerComponent,
    SkeletonComponent,
    ContentUnavailableComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsModule {}
